import React from 'react';
import { IS_DEMO } from '../constants/featureFlags';

/**
 * Prominent, always-visible banner marking the public DEMO environment.
 * Renders nothing outside the demo build (gated by REACT_APP_DEMO_MODE).
 */
function DemoBanner() {
  if (!IS_DEMO) return null;

  return (
    <div
      role="note"
      aria-label="Demo environment notice"
      style={{
        background: 'linear-gradient(90deg, #f59e0b, #f97316)',
        color: '#1f2937',
        padding: '10px 16px',
        textAlign: 'center',
        fontWeight: 700,
        fontSize: '0.95rem',
        lineHeight: 1.4,
        boxShadow: '0 2px 6px rgba(0,0,0,0.12)',
        position: 'sticky',
        top: 0,
        zIndex: 10000,
        letterSpacing: '0.2px',
      }}
    >
      <span role="img" aria-label="lab">🧪</span>{' '}
      <strong>DEMO ENVIRONMENT</strong> — This is a demonstration of the Literacy
      Assessment app populated with <strong>synthetic, de-identified data</strong>.
      It is not connected to any live classroom.
    </div>
  );
}

export default DemoBanner;
